import { render, staticRenderFns } from "./EducationTypeList.vue?vue&type=template&id=42070e10&"
import script from "./EducationTypeList.vue?vue&type=script&lang=js&"
export * from "./EducationTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports